// INFO - DesignTokens from new DS (@livechat/design-system-react-components) have type of string
export const withVar = (token: string): string => `var(${token})`;
